/*
 * Copyright (c) AXA Group Operations Spain S.A.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

const { Stopwords } = require('@nlpjs/core');

class StopwordsIt extends Stopwords {
  constructor(container, words) {
    super(container);
    this.name = 'stopwords-it';
    this.dictionary = {};
    const list = words || [
      'ad',
      'al',
      'allo',
      'ai',
      'agli',
      'all',
      'agl',
      'alla',
      'alle',
      'con',
      'col',
      'coi',
      'da',
      'dal',
      'dallo',
      'dai',
      'dagli',
      'dall',
      'dagl',
      'dalla',
      'dalle',
      'di',
      'del',
      'dello',
      'dei',
      'degli',
      'dell',
      'degl',
      'della',
      'delle',
      'in',
      'nel',
      'nello',
      'nei',
      'negli',
      'nell',
      'negl',
      'nella',
      'nelle',
      'su',
      'sul',
      'sullo',
      'sui',
      'sugli',
      'sull',
      'sugl',
      'sulla',
      'sulle',
      'per',
      'tra',
      'contro',
      'io',
      'tu',
      'lui',
      'lei',
      'noi',
      'voi',
      'loro',
      'mio',
      'mia',
      'miei',
      'mie',
      'tuo',
      'tua',
      'tuoi',
      'tue',
      'suo',
      'sua',
      'suoi',
      'sue',
      'nostro',
      'nostra',
      'nostri',
      'nostre',
      'vostro',
      'vostra',
      'vostri',
      'vostre',
      'mi',
      'ti',
      'ci',
      'vi',
      'lo',
      'la',
      'li',
      'le',
      'gli',
      'ne',
      'il',
      'un',
      'uno',
      'una',
      'ma',
      'ed',
      'se',
      'perché',
      'anche',
      'come',
      'dov',
      'dove',
      'che',
      'chi',
      'cui',
      'non',
      'più',
      'quale',
      'quanto',
      'quanti',
      'quanta',
      'quante',
      'quello',
      'quelli',
      'quella',
      'quelle',
      'questo',
      'questi',
      'questa',
      'queste',
      'si',
      'tutto',
      'tutti',
      'a',
      'c',
      'e',
      'i',
      'l',
      'o',
      'ho',
      'hai',
      'ha',
      'abbiamo',
      'avete',
      'hanno',
      'abbia',
      'abbiate',
      'abbiano',
      'avrò',
      'avrai',
      'avrà',
      'avremo',
      'avrete',
      'avranno',
      'avrei',
      'avresti',
      'avrebbe',
      'avremmo',
      'avreste',
      'avrebbero',
      'avevo',
      'avevi',
      'aveva',
      'avevamo',
      'avevate',
      'avevano',
      'ebbi',
      'avesti',
      'ebbe',
      'avemmo',
      'aveste',
      'ebbero',
      'avessi',
      'avesse',
      'avessimo',
      'avessero',
      'avendo',
      'avuto',
      'avuta',
      'avuti',
      'avute',
      'sono',
      'sei',
      'è',
      'siamo',
      'siete',
      'sia',
      'siate',
      'siano',
      'sarò',
      'sarai',
      'sarà',
      'saremo',
      'sarete',
      'saranno',
      'sarei',
      'saresti',
      'sarebbe',
      'saremmo',
      'sareste',
      'sarebbero',
      'ero',
      'eri',
      'era',
      'eravamo',
      'eravate',
      'erano',
      'fui',
      'fosti',
      'fu',
      'fummo',
      'foste',
      'furono',
      'fossi',
      'fosse',
      'fossimo',
      'fossero',
      'essendo',
      'faccio',
      'fai',
      'facciamo',
      'fanno',
      'faccia',
      'facciate',
      'facciano',
      'farò',
      'farai',
      'farà',
      'faremo',
      'farete',
      'faranno',
      'farei',
      'faresti',
      'farebbe',
      'faremmo',
      'fareste',
      'farebbero',
      'facevo',
      'facevi',
      'faceva',
      'facevamo',
      'facevate',
      'facevano',
      'feci',
      'facesti',
      'fece',
      'facemmo',
      'faceste',
      'fecero',
      'facessi',
      'facesse',
      'facessimo',
      'facessero',
      'facendo',
      'sto',
      'stai',
      'sta',
      'stiamo',
      'stanno',
      'stia',
      'stiate',
      'stiano',
      'starò',
      'starai',
      'starà',
      'staremo',
      'starete',
      'staranno',
      'starei',
      'staresti',
      'starebbe',
      'staremmo',
      'stareste',
      'starebbero',
      'stavo',
      'stavi',
      'stava',
      'stavamo',
      'stavate',
      'stavano',
      'stetti',
      'stesti',
      'stette',
      'stemmo',
      'steste',
      'stettero',
      'stessi',
      'stesse',
      'stessimo',
      'stessero',
      'stando',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      '0',
      '_',
    ];
    this.build(list);
  }
}

module.exports = StopwordsIt;
